import { calcDays, HistoryCriteria } from '../../../domain/history/HistoryCriteria'
import httpBuildQuery from '../../../httpBuildQuery'

export const FETCH_EVENTS = 'V2/Event/Fetch'

export const fetchEventsForHistory = (criteria: HistoryCriteria) => ({
    type: FETCH_EVENTS,
    payload: ({ fetchForApplication }) => {
        const { environment, service, date, granularity } = criteria
        const days = calcDays(date, granularity)
        const query = { env: environment, s: service, start: days[0], end: days[days.length - 1], type: 'release' }

        return fetchForApplication('/events/api/data?' + httpBuildQuery(query)).then(data => ({ environment, service, data }))
    },
})
